import { render } from "./ButtonRank112.vue?vue&type=template&id=a7ae3396&scoped=true"
const script = {}

import "./ButtonRank112.vue?vue&type=style&index=0&id=a7ae3396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ae3396"]])

export default __exports__